import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
}));

export default function Navbar() {
  const classes = useStyles();

  return (
    <AppBar position="static" style={{ boxShadow: "unset" }}>
      <Toolbar>
        <Typography variant="h6" className={classes.title}>
          <Link to="/"># Calories Calculator</Link>
        </Typography>
        <Typography variant="h6" style={{ justifyContent: "flex-end" }}>
          <Link to="/about">About Us</Link>
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
